import React, { useEffect, useCallback, useState} from 'react';
import GroupGeneticAlgo from "components/effects/plane/GroupGeneticAlgo.js";
import CheckboxParameter from './CheckboxParameter.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import ParameterKnob from 'components/knobs/ParameterKnob.js';
import {connect} from 'react-redux';

const GeneticWaveShaperComponent = ({effect, scrollContainer, sequencerEngine, effectNumber}) => { 
    return (
        <div>
          <CheckboxParameter parameter={effect.overSampleParameter} name="Oversample"/>
          <EffectParameterSlider
            effectNumber={effectNumber}
            name='Drive'
            sequencerEngine={sequencerEngine}
            lfoEnabled={true}
            parameter={effect.driveParameter}
            isParameter={true}
            step={0.01}
            max={32}
            min={0.01}
          />
          <GroupGeneticAlgo group={effect}/>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneticWaveShaperComponent);
